import { render, staticRenderFns } from "./EmailAuditList.vue?vue&type=template&id=2daa6cd5&scoped=true&"
import script from "./EmailAuditList.vue?vue&type=script&lang=ts&"
export * from "./EmailAuditList.vue?vue&type=script&lang=ts&"
import style0 from "./EmailAuditList.vue?vue&type=style&index=0&id=2daa6cd5&lang=scss&scoped=true&"
import style1 from "./EmailAuditList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa6cd5",
  null
  
)

export default component.exports